import { render, staticRenderFns } from "./project-compose-header.vue?vue&type=template&id=16f32a8f&"
import script from "./project-compose-header.vue?vue&type=script&lang=ts&"
export * from "./project-compose-header.vue?vue&type=script&lang=ts&"
import style0 from "./project-compose-header.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports